export default __webpack_public_path__ + "e9ccb0707c9f19dbe904d2e61c02c16f.png";